module.exports = __webpack_public_path__ + "img/step_1-2.d8756ada.png";